import React from "react";

// Customer-facing labels and display order for vehicle status.
const STATUS = {
    available: { label: "Available", cls: "bg-[#F7F3EB] text-[#33302C] border-[#E2D4C1]", rank: 0 },
    coming_soon: { label: "Coming Soon", cls: "bg-[#F7F3EB] text-gold border-gold/40", rank: 1 },
    pending: { label: "Reservation in progress", cls: "bg-amber-50 text-amber-800 border-amber-300", rank: 2 },
    reserved: { label: "Reserved", cls: "bg-gold text-white border-gold", rank: 3 },
    sold: { label: "Sold", cls: "bg-[#33302C] text-white border-[#33302C]", rank: 4 },
};

export const vehicleStatus = (s) => STATUS[s] || STATUS.available;

export default function VehicleStatus({ status, className = "", testId }) {
    const s = vehicleStatus(status);
    return (
        <span data-testid={testId} className={`inline-block px-2.5 py-1 border text-[10px] tracking-[0.2em] uppercase ${s.cls} ${className}`}>
            {s.label}
        </span>
    );
}
